import { Scene } from 'phaser';
import { TweenAction } from './TweenAction';

export class MoveAction extends TweenAction {
  protected x: number;
  protected y: number;

  constructor(scene: Scene, targets: any, duration: number, x: number, y: number) {
    super(scene, targets, duration);
    this.x = x;
    this.y = y;
  }

  protected setTweenConfig() {
    super.setTweenConfig();
    this.setTweenConfigValue('x', this.x);
    this.setTweenConfigValue('y', this.y);
  }
}